import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

interface RouteTransitionProps {
  children: React.ReactNode;
}

const RouteTransition: React.FC<RouteTransitionProps> = ({ children }) => {
  const location = useLocation();

  return (
    <Box
      key={location.pathname}
      sx={{
        animation: 'routeFade 0.45s cubic-bezier(0.4, 0, 0.2, 1) both',
        '@keyframes routeFade': {
          '0%': { opacity: 0, transform: 'translateY(8px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default RouteTransition;
